import React from "react";
import { formatScheduleDate } from "../../core/utils/assignedPlansUtils";

// One entry per status → one place to add a future status (e.g. "expired").
const STATUS_STYLES = {
  active: {
    emoji: "🟠",
    label: "Active",
    className:
      "bg-orange-100 text-orange-900 border border-orange-300",
  },
  upcoming: {
    emoji: "🔵",
    label: "Upcoming",
    className: "bg-blue-100 text-blue-800 border border-blue-300",
  },
};

/** Pill showing whether a diet plan is active/upcoming/unassigned. Data-only props so it's reusable outside this card. */
function ActivePlanBadge({ status, planTitle, startDate, endDate }) {
  const style = STATUS_STYLES[status];

  if (!style) {
    return (
      <span className="ml-3 text-xs font-medium text-gray-500">
        ⚠️ No Plan Assigned
      </span>
    );
  }

  const dateRange = `${formatScheduleDate(startDate)} – ${formatScheduleDate(endDate)}`;
  const title = planTitle || "Untitled plan";

  return (
    <span
      className={`ml-3 inline-flex items-center gap-1 max-w-full text-xs font-semibold px-3 py-1 rounded-full ${style.className}`}
    >
      <span className="shrink-0 whitespace-nowrap">
        {style.emoji} {style.label}:
      </span>
      <span className="truncate max-w-[10rem]" title={title}>
        {title}
      </span>
      <span className="shrink-0 whitespace-nowrap">({dateRange})</span>
    </span>
  );
}

export default React.memo(ActivePlanBadge);
